<ng-template #content_bulk_upload let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.bulk">
        <div class="side_popup_header">
            <span>{{localService.languageContent.bulk.title}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" [ngStyle]="{'max-height' : (localService.sideBarBodyHeight + 50) + 'px'}">
            <div *ngIf="excelTemplateType == 0">
                {{localService.languageContent.bulk.unavailable}}
            </div>
            <div *ngIf="excelTemplateType != 0">
                <div class="row">
                    <div class="col-12" style="text-align: center;">
                        <button class="button_link"
                            (click)="onAction(1)">{{localService.languageContent.bulk.download_template}}</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div style="text-align: center;margin-top: 50px;">
                            <app-file-upload [fileUploadFor]="FileUploadFor.BulkUsers" [isBigSizeIcon]="true" (onFileUploaded)="onCloseTrigger()"></app-file-upload>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-12" style="text-align: left;">
                    {{localService.languageContent.bulk.bg_task_info}}
                </div>
            </div>
        </div>
    </div>>
</ng-template>